import Image from 'next/legacy/image';

import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';

export const ToggleWrapper = styled('div')`
  height: ${pxToRem(20)};
  width: ${pxToRem(20)};
`;

export const ToggleIcon = styled(Image, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'none' : 'rotate(45deg)')};
  transition: 0.2s transform ease;
`;
